/*
 * MM 2026-10-21: buying on the product page, one owner (the MobileMonster port of the OzMobiles theme's
 * assets/oz-buy.js; Upsells repo docs/developer/theme-integration.md section 7). It replaces assets/custom-upsells.js
 * and the UFE app embed, so nothing else adds to the cart from main-product.
 *
 *   Add to cart ------------+
 *   sticky bar -------------+--> submit of form#product-form-<section> (the sticky button names it with form="")
 *                                 --> the capture listener below, before Vision's ProductForm sees it
 *                                 --> OzBuy.buy('cart', { section, button })
 *
 *   OzBuy.buy('cart')      resolves true once the cart holds the selections and the drawer is open, false otherwise
 *     1. selections        the variant on screen (and its quantity) + every switched-on in-page row
 *                          (.related_product_block_check_input:checked). A row drawn by the Upsells app carries
 *                          data-oz-token, which goes on the cart line as the private property _upsell (hidden at
 *                          checkout, kept on the order; the Discount Function and the analytics read it).
 *     2. upsell step       OzBuy.upsell.decide(ctx) === true -> OzBuy.upsell.open(ctx) (assets/oz-upsells.js, the
 *                          "Complete your order" pop-up), which ends with ctx.proceed(extraItems) ("No thanks" is
 *                          ctx.proceed([])) or ctx.cancel() (back, X, Escape: nothing is added). Otherwise straight on.
 *     3. cart              one /cart/add.js with every item (merged by "<variant id>|<token>") and Vision's cart
 *                          sections; a 422 (something sold out since the page loaded) retries the items one by one,
 *                          skips the failures (oz_upsells:error add_422) and stops only when the main variant failed
 *     4. drawer            the returned sections replace the cart page, the drawer and the cart count, and the drawer
 *                          opens, exactly as Vision's own Add to cart does (OzBuy.renderCart, also used by the cart
 *                          block's plus in assets/oz-upsells.js)
 *
 * MobileMonster has no express buttons on the product page (Vision's dynamic checkout is off), so the OzMobiles
 * Shop Pay, Checkout and wallet paths and their express ledger are not ported. After a successful add,
 * oz_upsells:add is published for the tokened quantities added.
 *
 * Only main-product is owned (it carries data-section-type="product"); the featured product, quick view and the
 * Disney template keep their own add to cart.
 */
(function () {
  'use strict';

  var TOKEN_RE = /^u1\.([ipc])\.(\d{1,7})\.(\d{1,7})\.(\d{1,9})$/;
  var EVENT_ITEMS = 50;
  // Vision's cart sections: [element id, section name, selector inside it] (assets/product.js ProductForm)
  var CART_SECTIONS = [
    ['Cart', 'main-cart', '.thb-cart-form'],
    ['Cart-Drawer', 'cart-drawer', '.cart-drawer'],
    ['cart-drawer-toggle', 'cart-bubble', '.thb-item-count']
  ];
  var INFO_TARGET = { warranty: '#exclamation_popup1', battery: '#exclamation_popup2' };
  var state = { busy: false, opening: false };

  var OzBuy = window.OzBuy = window.OzBuy || {};
  // assets/oz-upsells.js installs the real step; it may load before or after this file
  OzBuy.upsell = OzBuy.upsell || {
    decide: function () { return false; },
    open: function (ctx) { ctx.proceed([]); }
  };
  // the pop-up closes after proceed instead of waiting for a page load (assets/oz-upsells.js, MM)
  OzBuy.staysOnPage = true;
  OzBuy.cartSections = CART_SECTIONS.map(function (s) { return s[1]; });

  function tokenOf(item) { return (item && item.properties && item.properties._upsell) || ''; }
  function keyOf(id, token) { return String(id) + '|' + (token || ''); }
  function itemKey(item) { return keyOf(item.id, tokenOf(item)); }

  /* ---------- events (Upsells interfaces.md 7.1) ---------- */
  function publish(name, data) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (e) { /* analytics must never break buying */ }
  }
  function publishError(code, detail) {
    publish('oz_upsells:error', { v: 1, code: code, detail: String(detail || '').slice(0, 120) });
  }
  // added: [{ token, productId, variantId, quantity }]
  function publishAdded(added) {
    var byPl = {};
    added.forEach(function (a) {
      var m = TOKEN_RE.exec(a.token || '');
      if (!m || !(a.quantity > 0)) { return; }
      (byPl[m[1]] = byPl[m[1]] || []).push([Number(m[2]), Number(m[3]), Number(m[4]), Number(a.productId) || 0, Number(a.variantId), a.quantity]);
    });
    Object.keys(byPl).forEach(function (pl) {
      for (var i = 0; i < byPl[pl].length; i += EVENT_ITEMS) {
        publish('oz_upsells:add', { v: 1, pl: pl, items: byPl[pl].slice(i, i + EVENT_ITEMS) });
      }
    });
  }

  /* ---------- 1. selections ---------- */
  function productForm(section) {
    var id = section && section.getAttribute('data-section-id');
    return id ? document.getElementById('product-form-' + id) : null;
  }
  function selectionItems(section) {
    var form = productForm(section);
    var idInput = form && form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) { return []; }
    var qtyInput = document.querySelector('[name="quantity"][form="' + form.getAttribute('id') + '"]') || form.querySelector('[name="quantity"]');
    var items = [{ id: Number(idInput.value), quantity: Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1) }];
    section.querySelectorAll('.related_product_block_check_input:checked').forEach(function (input) {
      var row = input.closest('[data-oz-row]');
      if (row && row.hidden) { return; }
      var id = Number(String(input.value || '').trim());
      if (!id) { return; }
      var item = { id: id, quantity: 1 };
      var token = input.getAttribute('data-oz-token');
      if (token && TOKEN_RE.test(token)) { item.properties = { _upsell: token }; }
      items.push(item);
    });
    return items;
  }

  function mergeItems(items) {
    var byKey = {};
    var order = [];
    items.forEach(function (item) {
      var id = Number(item && item.id);
      if (!id) { return; }
      var quantity = Math.max(1, parseInt(item.quantity, 10) || 1);
      var token = tokenOf(item);
      var key = keyOf(id, token);
      if (!byKey[key]) {
        byKey[key] = { id: id, quantity: 0 };
        if (token) { byKey[key].properties = { _upsell: token }; }
        order.push(key);
      }
      byKey[key].quantity += quantity;
    });
    return order.map(function (key) { return byKey[key]; });
  }

  /* ---------- 3. cart ---------- */
  function httpError(status, text) {
    var error = new Error('POST /cart/add.js ' + status);
    error.status = status;
    var data = null;
    try { data = JSON.parse(text); } catch (e) { /* not JSON */ }
    error.message = (data && (data.description || data.message)) || error.message;
    return error;
  }
  function post(items, withSections) {
    var body = { items: items };
    if (withSections) {
      body.sections = OzBuy.cartSections.join(',');
      body.sections_url = window.location.pathname;
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.text().then(function (text) {
        if (!response.ok) { throw httpError(response.status, text); }
        return JSON.parse(text);
      });
    });
  }
  function productOf(response, item) {
    var list = (response && response.items) || [];
    for (var i = 0; i < list.length; i++) { if (Number(list[i].variant_id) === item.id) { return list[i].product_id; } }
    return 0;
  }
  function record(response, list) {
    return list.map(function (item) { return { token: tokenOf(item), productId: productOf(response, item), variantId: item.id, quantity: item.quantity }; });
  }
  // Resolves { ok, added, sections, message }; ok is false only when the main variant (first item) could not be added.
  function addItems(items) {
    var mainKey = itemKey(items[0]);
    return post(items, true).then(function (response) {
      return { ok: true, added: record(response, items), sections: response.sections || null };
    }, function (error) {
      if (error.status !== 422) { throw error; }
      if (items.length === 1) { return { ok: false, added: [], sections: null, message: error.message }; }
      var added = [];
      var ok = true;
      var message = '';
      var chain = Promise.resolve();
      items.forEach(function (item) {
        chain = chain.then(function () {
          if (!ok) { return null; }
          return post([item], false).then(function (response) {
            added = added.concat(record(response, [item]));
          }, function (one) {
            if (one.status !== 422) { throw one; }
            publishError('add_422', 'variant ' + item.id);
            if (itemKey(item) === mainKey) { ok = false; message = one.message; }
          });
        });
      });
      return chain.then(function () {
        if (!added.length) { return { ok: ok, added: added, sections: null, message: message }; }
        return fetch('/?sections=' + OzBuy.cartSections.join(','), { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; }, function () { return null; })
          .then(function (sections) { return { ok: ok, added: added, sections: sections, message: message }; });
      });
    });
  }

  /* ---------- 4. the drawer: Vision's cart page, drawer and count from returned sections ---------- */
  function innerOf(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }
  OzBuy.renderCart = function (data) {
    var sections = (data && data.sections) || data || {};
    CART_SECTIONS.forEach(function (s) {
      var host = document.getElementById(s[0]);
      var html = sections[s[1]];
      if (!host || !html) { return; }
      var target = host.querySelector(s[2]) || host;
      var inner = innerOf(html, s[2]);
      if (inner !== null) { target.innerHTML = inner; }
    });
    // re-bind the drawer's and the cart page's own controls without adding a second change listener to their roots
    try {
      if (typeof CartDrawer !== 'undefined' && document.getElementById('Cart-Drawer')) {
        var drawer = Object.create(CartDrawer.prototype);
        drawer.container = document.getElementById('Cart-Drawer');
        drawer.removeProductEvent();
        drawer.notesToggle();
        drawer.termsCheckbox();
      }
      if (typeof Cart !== 'undefined' && document.getElementById('Cart')) {
        var page = Object.create(Cart.prototype);
        page.container = document.getElementById('Cart');
        page.container.querySelectorAll('.remove').forEach(function (remove) {
          remove.addEventListener('click', function (event) { page.updateQuantity(event.target.dataset.index, '0'); event.preventDefault(); });
        });
        page.termsCheckbox();
      }
    } catch (e) { if (window.console) { console.warn('[mm-buy] cart controls:', e); } }
    document.documentElement.dispatchEvent(new CustomEvent('cart:rerendered', { bubbles: true }));
  };
  function openDrawer() {
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer) { window.location.href = '/cart'; return; }
    var search = document.getElementById('Search-Drawer');
    if (search) { search.classList.remove('active'); }
    document.body.classList.add('open-cc');
    drawer.classList.add('active');
    if (typeof window.dispatchCustomEvent === 'function') { window.dispatchCustomEvent('cart-drawer:open'); }
  }
  // the theme re-renders the drawer or the cart page itself after a quantity change: its cart block needs its listeners
  document.addEventListener('line-item:change:end', function () {
    document.documentElement.dispatchEvent(new CustomEvent('cart:rerendered', { bubbles: true }));
  });

  /* ---------- buttons: Vision's loading state and error line ---------- */
  function setLoading(on) {
    document.querySelectorAll('.single-add-to-cart-button').forEach(function (button) {
      if (on) { button.setAttribute('aria-disabled', 'true'); button.classList.add('loading'); } else { button.removeAttribute('aria-disabled'); button.classList.remove('loading'); }
    });
  }
  function showError(section, message) {
    var form = productForm(section);
    var holder = form && form.closest('product-form');
    if (holder && typeof holder.handleErrorMessage === 'function') { holder.handleErrorMessage(message || false); }
  }

  /* ---------- the one buy function ---------- */
  function begin(kind, options) {
    if (kind !== 'cart' || state.busy || state.opening) { return Promise.resolve(false); }
    var section = options.section;
    var selections = selectionItems(section);
    if (!selections.length) { return Promise.resolve(false); }
    var settled = false;
    var resolveRun = null;
    var run = new Promise(function (resolve) { resolveRun = resolve; });
    var finish = function (value) {
      if (settled) { return; }
      settled = true;
      state.busy = false;
      state.opening = false;
      setLoading(false);
      resolveRun(value);
    };
    showError(section, false);
    var ctx = {
      kind: kind,
      wallet: false,
      walletTag: '',
      section: section,
      selections: selections,
      // continue, from here or from the pop-up with the extras the shopper picked; true once the drawer is open
      proceed: function (extraItems) {
        if (settled || state.busy) { return Promise.resolve(false); }
        state.opening = false;
        state.busy = true;
        setLoading(true);
        var items = mergeItems(selections.concat(extraItems || []));
        return addItems(items).then(function (result) {
          if (!result.ok) {
            showError(section, result.message);
            if (window.console) { console.warn('[mm-buy] the selected variant could not be added'); }
            if (result.sections) { OzBuy.renderCart(result.sections); }
            finish(false);
            return false;
          }
          publishAdded(result.added.filter(function (a) { return a.token; }));
          if (result.sections) { OzBuy.renderCart(result.sections); }
          if (typeof window.dispatchCustomEvent === 'function') { window.dispatchCustomEvent('cart:item-added', { product: items[0] }); }
          finish(true);
          openDrawer();
          return true;
        }, function (error) {
          showError(section, error && error.message);
          if (window.console) { console.warn('[mm-buy] add to cart failed:', error); }
          finish(false);
          return false;
        });
      },
      // close, add nothing: the buttons work again
      cancel: function () {
        if (settled || state.busy) { return; }
        finish(false);
      },
      walletFill: function () { return false; }
    };
    // 2. upsell step; a fault in it never blocks buying
    var open = false;
    try { open = OzBuy.upsell.decide(ctx) === true; } catch (e) { open = false; }
    if (!open) { ctx.proceed([]); return run; }
    state.opening = true;
    try {
      OzBuy.upsell.open(ctx);
    } catch (e) {
      state.opening = false;
      if (window.console) { console.warn('[mm-buy] upsell step failed:', e); }
      ctx.proceed([]);
    }
    return run;
  }

  OzBuy.buy = function (kind, options) { return begin(kind, options || {}); };

  // Every submit of main-product's form (its own button, the sticky bar's, Enter in the quantity) comes here first:
  // capture on document runs before Vision's ProductForm listener on the form, which never sees it.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    // getAttribute, not form.id: the product form holds an input named "id", which form.id returns
    var formId = form && form.getAttribute ? form.getAttribute('id') || '' : '';
    if (formId.indexOf('product-form-') !== 0) { return; }
    var section = form.closest('[data-section-type="product"]');
    if (!section || productForm(section) !== form) { return; }
    event.preventDefault();
    event.stopImmediatePropagation();
    var button = event.submitter || form.querySelector('[type="submit"]');
    if (button && (button.disabled || button.classList.contains('loading'))) { return; }
    OzBuy.buy('cart', { section: section, button: button });
  }, true);

  // A row's (i) opens MobileMonster's own warranty or battery pop-up (sections/header.liquid, shown by :target)
  document.addEventListener('click', function (event) {
    var info = event.target && event.target.closest ? event.target.closest('[data-oz-im-open]') : null;
    if (!info) { return; }
    event.preventDefault();
    event.stopPropagation();
    var target = INFO_TARGET[info.getAttribute('data-oz-im-open')];
    if (target) { window.location.hash = target; }
  });

  // back from checkout with the browser's back button (page restored from memory): buttons work again
  window.addEventListener('pageshow', function () {
    state.busy = false;
    state.opening = false;
    setLoading(false);
  });
})();
